<template>
  <div>
    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="blue accent-4"
      dark
      @click="fecharNotificacao"
    >
      {{ newNotify.text }}
    </v-alert>

    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="tableItens"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" persistent>
              <v-progress-linear
                :active="isLoadingRequestDisable"
                indeterminate
                color="green accent-4"
                height="7"
              ></v-progress-linear>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  >{{ newRowButtonText }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          v-show="alertModal"
                          border="left"
                          close-text="Close Alert"
                          color="orange"
                          dark
                          @click="fecharNotificacao"
                        >
                          Nota já enviada
                        </v-alert>
                      </v-col>

                      <v-col
                        v-for="(fieldForm, i) in modalFormComposition"
                        :key="i"
                        :cols="fieldForm.size"
                        :sm="fieldForm.size"
                        :md="fieldForm.size"
                      >
                        <v-text-field
                          :label="fieldForm.title"
                          v-if="
                            fieldForm.type == 'text' ||
                              fieldForm.type == 'number'
                          "
                          v-model="editedItem[fieldForm.modelName]"
                        ></v-text-field>

                        <span v-if="fieldForm.type == 'date'">{{
                          fieldForm.title
                        }}</span>
                        <br />
                        <input
                          type="date"
                          v-if="fieldForm.type == 'date'"
                          v-model="editedItem[fieldForm.modelName]"
                          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                        />
                        <v-autocomplete
                          v-if="
                            fieldForm.type == 'select' &&
                              editedItem['dispensaAutomatica'] == true
                          "
                          :label="fieldForm.title"
                          :items="listsOptions[fieldForm.modelName]"
                          v-model="editedItem['numero' + fieldForm.modelName]"
                        >
                        </v-autocomplete>

                        <v-file-input
                          v-if="fieldForm.type == 'file'"
                          v-model="editedItem[fieldForm.modelName]"
                          placeholder="Documento"
                          :label="fieldForm.title"
                          prepend-icon="mdi-paperclip"
                          @change="uploadXML($event)"
                        >
                          <template v-slot:selection="{ text }">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>

                        <v-checkbox
                          v-if="fieldForm.type == 'checkbox'"
                          :label="fieldForm.title"
                          v-model="editedItem[fieldForm.modelName]"
                          :value="true"
                        ></v-checkbox>
                      </v-col>
                      <div id="preview">
                        <img
                          v-if="editedItem['Base64ImagemItem']"
                          v-bind:src="
                            'data:image/png;base64,' +
                              editedItem['Base64ImagemItem']
                          "
                        />
                      </div>
                      <div id="preview">
                        <img
                          v-if="editedItem['Base64ImagemNota']"
                          v-bind:src="
                            'data:image/png;base64,' +
                              editedItem['Base64ImagemNota']
                          "
                        />
                      </div>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-4" text @click="closeModal"
                    >Fechar</v-btn
                  >

                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="isModalButtonDisabled"
                    @click="insert"
                    v-if="!isEdition"
                    >Concluir</v-btn
                  >
                  <v-btn
                    color="green darken-1"
                    text
                    :disabled="isModalButtonDisabled"
                    @click="update"
                    v-if="isEdition"
                    >Concluir</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.quantidadeAtual`]="{ item }">
          <v-chip
            :color="getColor(item.quantidadeTotal, item.quantidadeAtual).color"
            dark
            >{{ item.quantidadeAtual }}</v-chip
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="getColor(item.quantidadeTotal, item.quantidadeAtual)">
            <v-tooltip
              v-if="
                getColor(item.quantidadeTotal, item.quantidadeAtual)
                  .isSolicitacao
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="emitDataTableSolicitRowEvent(item)"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-alert-circle</v-icon
                >
              </template>
              <span>Solicitar Material</span>
            </v-tooltip>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import store from "@/store/index";
import axios from "../plugins/axios";

export default {


  props: {
    classTitle: String, // Titulo da classe que estamos recebendo
    tableTitle: String, // Titulo da tabela que vamos mostrar
    newRowButtonText: String, // Texto do botão 'Novo'
    tableHeader: Array, // Configurações da Tabela
    tableData: Array, // Conteudo da tabela
    modalFormComposition: Array, // Formulário da modal
    onUpdate: Function, // Função que atualiza os dados da tabela
    onInsert: Function, // Função que insere o item no banco
    onDelete: Function, // Função de delata o item do banco
    onUpdateDataTable: Function, // Função que popula a tabela
    onUpdateoptions: Function, //
    isLoadingRequestDisable: Boolean, // Função que habilita e desabilita LoadingRequest
  },

  directives: { TheMask },

  watch: {
    enderecoSelecionado() {
      this.initialize();
    },
    editedItem() {},
  },

  data: function() {
    return {
      alertModal: false,
      newNotify: {
        isNewNotify: false,
        text: "",
      },
      isModalButtonDisabled: true,
      imgB64NotaFiscal: "",
      imgB64NotaFotoItem: "",
      urlImg: null,
      urlImg2: null,
      search: "",
      dialog: false,
      dialog3: false,
      menu2: false,
      headers: this.tableHeader,
      tableItens: [],
      listsOptions: [],
      isEdition: false,
      editedItem: {},
      defaultItem: {},
      excluirItem: {},
      listEndereco: [],
      enderecoSelecionado: null,
      listItenUpload: [],
      listItenUploadNew: [],
    };
  },

  computed: {
    formTitle() {
      return !this.isEdition ? this.tableTitle : "Editar " + this.tableTitle;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    mostrarListaUnidades() {},

    async listOfEndereco() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };
      const responseEnderecos = await axios.get("enderecoordemservico", config);
      this.listEndereco = responseEnderecos.data.map((row) => {
        return {
          value: row.numeroEnderecoOrdemServico,
          text: row.nomeEndereco,
        };
      });
    },

    async uploadXML(e) {
      this.isModalButtonDisabled = true;

      if (e) {
        this.imgB64NotaFotoItem = await this.getXML(e);
        let obj = await this.parseFile(this.imgB64NotaFotoItem);
        this.listItenUpload = obj.getElementsByTagName("prod");
        let lote = obj.getElementsByTagName("infAdProd");
        const dataEmissao = obj.getElementsByTagName("ide")[0].childNodes[6]
          .innerHTML;

        for (let i = 0; i < this.listItenUpload.length; i++) {
          let nomeSemMarca = "";
          if (this.listItenUpload[i].childNodes[2].innerHTML.split("(")) {
            nomeSemMarca = this.listItenUpload[i].childNodes[2].innerHTML.split(
              "("
            )[0];
          } else {
            nomeSemMarca = this.listItenUpload[i].childNodes[2].innerHTML;
          }

          this.listItenUploadNew.push(
            new Object({
              codigoProduto: this.listItenUpload[i].childNodes[0].innerHTML,
              nomeProduto: nomeSemMarca,
              unidadeMedida: this.listItenUpload[i].childNodes[11].innerHTML,
              quantidadeItem: this.listItenUpload[i].childNodes[12].innerHTML,
              descricaoTela: "itensNDispensados",
              lote: lote[i].innerHTML.split("-")[1].split("(")[1],
              validade: lote[i].innerHTML.split("-")[2].split(")")[0],
              valorUnitario: this.listItenUpload[i].childNodes[13].innerHTML,
              cnpjEmpresa: obj.getElementsByTagName("emit")[0].childNodes[0]
                .innerHTML,
              razaoSocialEmpresa: obj.getElementsByTagName("emit")[0]
                .childNodes[1].innerHTML,
              nomeFantasiajEmpresa: obj.getElementsByTagName("emit")[0]
                .childNodes[2].innerHTML,
              valorTotalNota: obj.getElementsByTagName("total")[0].childNodes[0]
                .childNodes[8].innerHTML,
              numeroNota: obj.getElementsByTagName("infProt")[0].childNodes[2]
                .innerHTML,
              dataEmissao: dataEmissao.split("T")[0],
            })
          );
        }
      }
      this.isModalButtonDisabled = false;
      // await this.validarNota();
    },

    async validarNota() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      };
      const validar = await axios.put(
        "validarNota",
        { numeroNota: this.listItenUploadNew[0].numeroNota },
        config
      );

      this.isModalButtonDisabled = validar.data;

      if (validar.data) {
        this.alertModal = true;
      }
    },

    async parseFile(file) {
      let doc = new DOMParser().parseFromString(file, "text/xml");

      return doc;
    },

    async getXML(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    emitDataTableSolicitRowEvent(row) {
      this.$emit("datatable-solicitrow", row);
    },

    getColor(total, atual) {
      let perc = ((atual / total) * 100).toFixed(3);
      if (perc >= 30) {
        const Option = {
          color: "green",
          isSolicitacao: false,
        };

        return Option;
      }
      if (perc < 30 && perc > 0) {
        const Option = {
          color: "orange",
          isSolicitacao: true,
        };

        return Option;
      }
      if (perc < 0) {
        const Option = {
          color: "red",
          isSolicitacao: true,
        };

        return Option;
      }
      if (atual == 0) {
        const Option = {
          color: "back",
          isSolicitacao: true,
        };
        return Option;
      }

      return {
        color: "green",
        isSolicitacao: false,
      };
    },

    async initialize() {
      try {
        await this.listOfEndereco();
        this.setDefaultItens();

        var config = {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": store.state.token,
          },
        };

        const response = await axios.get("itemForInseridos", config);

        this.tableItens = response.data;

        for (let fieldForm of this.modalFormComposition) {
          if (fieldForm.type == "select") {
            this.listsOptions[fieldForm.modelName] = await this.onUpdateoptions(
              fieldForm.modelName
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    openPage(page) {
      this.$router.push(page);
    },

    async updataTable() {
      try {
        this.tableItens = await this.onUpdateDataTable();
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.isEdition = true;
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    closeModal() {
      this.editedItem = Object.assign({}, []);
      this.isEdition = false;

      this.dialog = false;
    },

    setDefaultItens() {
      this.modalFormComposition.forEach((fieldForm) => {
        if (fieldForm.type == "select") {
          this.listsOptions[fieldForm.modelName] = "";
        }
        if (fieldForm.type == "number") {
          this.defaultItem[fieldForm.modelName] = "";
          this.excluirItem[fieldForm.modelName] = "";
        }
        if (fieldForm.type == "checkbox") {
          this.defaultItem[fieldForm.modelName] = false;
        }
        if (fieldForm.type == "date") {
          this.defaultItem[fieldForm.modelName] = "";
        } else {
          this.defaultItem[fieldForm.modelName] = "";
          this.excluirItem[fieldForm.modelName] = "";
        }
      });
      this.excluirItem["numero" + this.classTitle];
    },

    async insert() {
      try {
        this.isModalButtonDisabled = true;
        this.editedItem["anexoFile"] = this.listItenUploadNew;
        await this.onInsert(this.editedItem);
        this.updataTable();
        this.listItenUploadNew = [];
        await this.initialize();
      } catch (error) {
        console.log(error);
      } finally {
        this.isModalButtonDisabled = false;
        this.closeModal();
      }
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    async update() {
      try {
        this.isModalButtonDisabled = true;
        const item = await this.editedItem;
        if (this.imgB64NotaFiscal) {
          item["imgB64NotaFiscal"] = this.imgB64NotaFiscal;
        }
        if (this.imgB64NotaFotoItem) {
          item["imgB64ImagemItem"] = this.imgB64NotaFotoItem;
        }
        await this.onUpdate(item);
        this.updataTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.isModalButtonDisabled = false;
        this.closeModal();
      }
    },

    async deleteItem(item) {
      if (confirm("Tem certeza que deseja deletar essa unidade de medida?")) {
        this.excluirItem["numero" + this.classTitle] = await item[
          "numero" + this.classTitle
        ];
        try {
          await this.onDelete(item);
          this.updataTable();
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>
<style scoped>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}
</style>
